import React, { useReducer, useEffect } from "react";
import axios from "axios";
import leloContext from "./leloContext";
import LeloReducer from "./leloReducer";
import ErrorLogger from "../../components/ErrorLogger";
import setAuthToken from "../../functions/auth_header";
import Image from "../../img/respondicon.png";
import {
  GET_LELO_DATA,
  SUBMIT_DATA,
  LEVEL_UP,
  LEVEL_DOWN,
  ON_FORM_DATA_CHANGE,
  SET_PASS,
  GET_AGE,
  GET_LELO_COURSES,
  GET_LELO_COURSES_CHARTERID,
  GET_LELO_DATA_UUID,
  GET_LELO_COURSES_PERMALINK,
  GET_LELO_SESSION,
  GET_LELO_SESSION1
} from "../types";
import { getAppUrl } from "../../functions/getEnv";


// Initial state based on leloSchema
const initialState = {
  formData: {
    createdAt: new Date().toLocaleString(),
    charter: "",
    siteId: "",
    learningCenter: [],
    name: "",
    charter_id: "",
    uploadedUrl: "",
    hasPreviouslyEnrolled: "",
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    birthDate: "",
    studentEmail: "",
    studentPrimaryPhone: "",
    studentPrimaryPhoneType: "",
    understood: "",

    pgRelationshipToStudent: "",
    pgFirstName: "",
    pgLastName: "",
    pgPrimaryEmail: "",
    pgPrimaryPhone: "",
    pgPrimaryPhoneType: "",

    liveWithPg: false,
    livingStatus: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    district: "",
    isMailingAddressTheSame: false,

    mailingStreet: "",
    mailingCity: "",
    mailingState: "",
    mailingZip: "",

    gradeLevel: "",
    courses: [],
    selectedCourseAgreements: [],

    studentSignature: "",
    studentName: "",
    studentSignatureDate: null,
    parentSignature: "",
    parentName: "",
    parentSignatureDate: null,
  },
  age: 0,
  domainName: {},
  pass: {
    initial: true,
    student: true,
    parents: true,
    physical: true,
    mailing: true,
    course: true,
    master: true,
  },
  leloCourse: [],
  leloData: [],
  leloDatauuid: [],
  leloCoursecarterid: [],
  leloDatapermalink: [],
  leloSession: [],
  leloSession1: [],
};

const LeloState = (props) => {
  const [state, dispatch] = useReducer(LeloReducer, initialState);

  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);

  const getLeloSession = async (sesson_id) => {
    try {
      const authRes = await axios.get(`${appUrl}/auth/webapp`);
      const userAccessToken = authRes.data.accessTokens[0];
      setAuthToken(userAccessToken);

      const response = await axios.get(`${appUrl}/api/sessions/${sesson_id}`, {
        params: {
          LeloRegistrationProfile: sesson_id,
        },
      });
      dispatch({
        type: GET_LELO_SESSION,
        payload: { data: response.data },
      });

    } catch (error) {
      ErrorLogger.logError(error.message);
    }
  };
  const getLeloSession1 = async (permalink) => {
    try {
      const authRes = await axios.get(`${appUrl}/auth/webapp`);
      const userAccessToken = authRes.data.accessTokens[0];
      setAuthToken(userAccessToken);

      const response = await axios.get(`${appUrl}/api/sessions/${permalink}`);
      dispatch({
        type: GET_LELO_SESSION1,
        payload: { data: response.data },
      });

    } catch (error) {
      console.error("Error retrieving sessions:", error.message);
      ErrorLogger.logError(error.message);
      // Dispatch an empty data array to prevent undefined errors
      dispatch({
        type: GET_LELO_SESSION1,
        payload: { data: [] },
      });
    }
  };

  const getLelo = async () => {
    try {
      const authRes = await axios.get(`${appUrl}/auth/webapp`);
      const userAccessToken = authRes.data.accessTokens[0];
      setAuthToken(userAccessToken);
      const response = await axios.get(`${appUrl}/api/leloRegistration`);

      dispatch({
        type: GET_LELO_DATA,
        payload: { data: response.data },
      });
    } catch (error) {
      console.error("Error retrieving data:", error);
      ErrorLogger.logError(error.message);
    }
  };

  const getCourses = async (siteId, charter_id, LeloRegistrationProfile) => {
    try {
      const authRes = await axios.get(`${appUrl}/auth/webapp`);
      const userAccessToken = authRes.data.accessTokens[0];
      setAuthToken(userAccessToken);
      const response = await axios.get(`${appUrl}/api/courses/${siteId}/${charter_id}/${LeloRegistrationProfile}`, {
        params: {
          LeloRegistrationProfile: LeloRegistrationProfile,
          siteId: siteId,
          charter_id: charter_id
        },
      });

      dispatch({
        type: GET_LELO_COURSES,
        payload: { data: response.data },
      });
    } catch (error) {
      console.error("Error retrieving data:", error);
      ErrorLogger.logError(error.message);
    }
  };

  // const getCoursesByPermalink = async (_id) => {
  //   try {
  //     const authRes = await axios.get(`${appUrl}/auth/webapp`);
  //     const userAccessToken = authRes.data.accessTokens[0];
  //     setAuthToken(userAccessToken);
  //     const response = await axios.get(`${appUrl}/api/courses/${_id}`, {
  //       params: {
  //         _id: _id,
  //       },
  //     });
  //     dispatch({
  //       type: GET_LELO_COURSES_PERMALINK,
  //       payload: { data: response.data },
  //     });
  //   } catch (error) {
  //     console.error("Error retrieving data:", error);
  //     ErrorLogger.logError(error.message);
  //   }
  // };

  const getCoursesByPermalink = async (permalink) => {
    try {
      const authRes = await axios.get(`${appUrl}/auth/webapp`);
      const userAccessToken = authRes.data.accessTokens[0];
      setAuthToken(userAccessToken);
      const response = await axios.get(`${appUrl}/api/courses/${permalink}`, {
        params: {
          permalink: permalink,
        },
      });
      dispatch({
        type: GET_LELO_COURSES_PERMALINK,
        payload: { data: response.data },
      });
    } catch (error) {
      console.error("Error retrieving data:", error);
      ErrorLogger.logError(error.message);
    }
  };

  const getLeloData = async () => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const response = await axios.get(`${appUrl}/api/leloRegistration`);

      dispatch({
        type: GET_LELO_DATA,
        payload: { data: response.data },
      });
    } catch (error) {
      console.error("Error retrieving data:", error);
      ErrorLogger.logError(error.message);
    }
  };

  const getLeloDataUuid = async (_uuid) => {
    try {

      const authRes = await axios.get(`${appUrl}/auth/webapp`);
      const userAccessToken = authRes.data.accessTokens[0];
      setAuthToken(userAccessToken);

      const response = await axios.get(`${appUrl}/api/leloRegistration/${_uuid}`);

      dispatch({
        type: GET_LELO_DATA_UUID,
        payload: { data: response.data },
      });
    } catch (error) {
      console.error("Error retrieving data:", error);
      ErrorLogger.logError(error.message);
    }
  };

  const getCoursescharterId = async (learningCenterName, charter_id) => {
    try {
      const authRes = await axios.get(`${appUrl}/auth/webapp`);
      const userAccessToken = authRes.data.accessTokens[0];
      setAuthToken(userAccessToken);
      const response = await axios.get(`${appUrl}/api/courses/${learningCenterName}/${charter_id}`);
      dispatch({
        type: GET_LELO_COURSES_CHARTERID,
        payload: { data: response.data },
      });
    } catch (error) {
      console.error("Error retrieving data:", error);
      ErrorLogger.logError(error.message);
    }
  };

  const levelUp = () => {
    dispatch({ type: LEVEL_UP });
  };

  const levelDown = () => {
    dispatch({ type: LEVEL_DOWN });
  };

  const getAge = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var newAge = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      newAge--;
    }
    dispatch({ type: GET_AGE, payload: newAge });
  };

  const setPass = (name, value) => {
    dispatch({ type: SET_PASS, payload: { name, value } });
  };

  const submitLeloForm = async (data) => {
    try {
      const authRes = await axios.get(`${appUrl}/auth/webapp`);
      const userAccessToken = authRes.data.accessTokens[0];
      setAuthToken(userAccessToken);

      const currURL = window.location.href;
      const site_id = currURL.slice(-24);
      data.learningCenterId = site_id;

      const res = await axios.post(`${appUrl}/api/leloRegistration`, data, {
        headers: {
          "Content-Type": "application/json",
          Secret: import.meta.env.VITE_API_SECRET,
        },
      });
      const _uuid = res.data._uuid;
      dispatch({ type: SUBMIT_DATA });
      return _uuid; // Return the _uuid as the Registration ID
    } catch (error) {
      console.error(`Error in submitLeloForm: ${error.message}`);
      ErrorLogger.logError(`Error in submitLeloForm: ${error.message}`); // Log error using a custom logger
      return null;
    }
  };



  const fullLeloFormSubmit = async (_uuid, data) => {
    try {
      const authRes = await axios.get(`${appUrl}/auth/webapp`);
      const userAccessToken = authRes.data.accessTokens[0];
      setAuthToken(userAccessToken);

      const currURL = window.location.href;
      const site_id = currURL.slice(-24);
      data.learningCenterId = site_id;

      const res = await axios.put(`${appUrl}/api/leloRegistration/${_uuid}`, data, {
        headers: {
          "Content-Type": "application/json",
          Secret: import.meta.env.VITE_API_SECRET,
        },
      });


      dispatch({ type: SUBMIT_DATA });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message); // Log error using a custom logger
    }
  };

  const onFormDataChange = (e) => {
    if (e && e.target && e.target.name) {
      dispatch({
        type: ON_FORM_DATA_CHANGE,
        payload: {
          name: e.target.name,
          value:
            e.target.type === "radio"
              ? e.target.name === "previouslyEnrolled"
                ? e.target.value === "yes"
                  ? { yes: true, no: false, "not sure": false }
                  : e.target.value === "no"
                    ? { yes: false, no: true, "not sure": false }
                    : { yes: false, no: false, "not sure": true }
                : e.target.value === "yes"
                  ? { yes: true, no: false }
                  : { yes: false, no: true }
              : e.target.value,
        },
      });
    } else {
      console.error("Event target is undefined");
    }
  };

  const sendleloEmail = async (data) => {
    const authRes = await axios.get(`${appUrl}/auth/webapp`);
    const userAccessToken = authRes.data.accessTokens[0];
    setAuthToken(userAccessToken);

    try {
      // Extract brand name from learning center
      const brandName = data.selectedLearningCenter
        ? data.selectedLearningCenter.split("-")[0].trim()
        : "Unknown";

      // Get email preferences from API
      const emailPrefsResponse = await axios.get(
        `${appUrl}/api/leloEmailTemplate/${data.charter_id}/${data.LeloRegistrationProfile}/${data.siteId}`
      );

      // Default template message
      let templateMessage =
        "You are considered registered and there is nothing more you need to do unless you are contacted by the school for additional information. One of our staff members will contact you with instructions and information on how to start your course. They will also be able to answer any questions you may have. We look forward to working with you!";

      try {
        const messagetemplate = await axios.get(
          `${appUrl}/api/lelotemplate/${data.charter_id}/${data.LeloRegistrationProfile}/${data.siteId}`
        );
        if (messagetemplate.data && messagetemplate.data.templateMessage) {
          templateMessage = messagetemplate.data.templateMessage;
        }
      } catch (templateError) {
        console.log(
          "Using default template message as no custom template was found"
        );
      }

      const emailPrefs = emailPrefsResponse.data;

      // Prepare email data based on preferences
      const emailData = {
        firstName: data.firstName,
        lastName: data.lastName,
        charter: data.charter,
        charter_id: data.charter_id,
        permaLink: data.permaLink,
        learningCenters: data.selectedLearningCenter,
        brandName: brandName,
        studentEmail: emailPrefs.studentEmail ? data.studentEmail : null,
        pgPrimaryEmail: emailPrefs.pgPrimaryEmail
          ? data.pgPrimaryEmail || null
          : null,
        templateMessage: templateMessage,
        _uuid: data._uuid,
        Image: Image,
        courses: data.courses,
        selectedCourseAgreements: data.selectedCourseAgreements,
        siteId: data.siteId,
        LeloRegistrationProfile: data.LeloRegistrationProfile,
        leloRecordId: data._uuid, // Add leloRecordId for email logger
      };

      // Student or Parent Email Notification - Only when True
      if (emailData.studentEmail || emailData.pgPrimaryEmail) {
        // Send Student/Parent Email Request
        const res = await axios.post(
          `${appUrl}/api/email/lelo-email`,
          emailData
        );
      }

      // Additional Admin Notifications - Only when True
      if (emailPrefs.email && emailPrefs.email.length > 0) {
        const adminEmailData = {
          ...emailData,
          email: emailPrefs.email, // Pass the admin emails array
          leloRecordId: data._uuid, // Ensure leloRecordId is passed for admin notifications
        };

        const res1 = await axios.post(
          `${appUrl}/api/email/lelo-notification-email`,
          adminEmailData
        );
      }
    } catch (error) {
      console.error("Error sending email:", error.message);
      ErrorLogger.logError(error.message);
    }
  };

  return (
    <leloContext.Provider
      value={{
        formData: state.formData,
        age: state.age,
        pass: state.pass,
        FilledOut: state.FilledOut,
        studentFilledOut: state.studentFilledOut,
        parentFilledOut: state.parentFilledOut,
        physicalFilledOut: state.physicalFilledOut,
        mailingFiledOut: state.mailingFiledOut,
        CourseFilledOut: state.CourseFilledOut,
        masterFilledOut: state.masterFilledOut,
        leloCourse: state.leloCourse,
        leloData: state.leloData,
        leloDatauuid: state.leloDatauuid,
        leloDatapermalink: state.leloDatapermalink,
        leloCoursecarterid: state.leloCoursecarterid,
        leloSession: state.leloSession,
        leloSession1: state.leloSession1,
        setPass,
        getAge,
        levelUp,
        levelDown,
        submitLeloForm,
        getLelo,
        onFormDataChange,
        fullLeloFormSubmit,
        getCourses,
        getLeloData,
        getCoursescharterId,
        getLeloDataUuid,
        getCoursesByPermalink,
        sendleloEmail,
        getLeloSession,
        getLeloSession1,
      }}>
      {props.children}
    </leloContext.Provider>
  );
};

export default LeloState;
